<template>
	<div
		class="job-results--item"
		v-inview:enter="comesToViewport"
		v-inview:leave="leavesViewport"
	>
		<div class="job-results--item-head">
			<div>
				<a
					href="#"
					class="job-results--item--title"
					@click.prevent="openVitaFan"
				>
					{{ applicantName }}
				</a>
			</div>
			<div class="job-list-item-more-infos">
				<a href="#" @click.prevent="openVitaFan">mehr Infos</a>
			</div>
		</div>
		<div>
			<div v-if="!loadedMatching" class="job-results--item--loading-placeholder">
				<div>&nbsp;</div>
			</div>
			<div :class="{'d-none': !loadedMatching}">
				<Matching
					:job-profile-id="jobProfile.id"
					:job-id="jobId"
					:applicant="applicant"
					:in-viewport="inViewport"
					narrow-label
					@loaded="loadedMatching = true"
					@click="openVitaFan"
				/>
				<div v-if="localApplicant" class="job-list-item-actions">
					<Button
						v-if="!localApplicant.communication.hasOngoingConversation"
						text="Jetzt kontaktieren"
						class="mr-2"
						secondary
						@click="contactNow"
					/>
					<Actions
						:job-profile-list-item="jobProfileListItem"
						:applicant="localApplicant"
						:job-id="jobId"
						:permissions="permissions"
						@applicantChanged="localApplicant = applicant"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Matching from "@/vue/customer/job-profile/applicant/Matching";
import {mapActions} from "vuex";
import {get} from "@/helper/job-profile/applicant/Name";
import GetList from "@/api/customer/job-profile/applicant/GetList";
import Button from "@/vue/common/Button.vue";
import _ from "lodash";
import Add from "@/api/event/Add";
import {PORTAL_CUSTOMER_CONTACTING_CLICK, PORTAL_CUSTOMER_VITA_LOAD} from "@/helper/event/Category";
import Actions from "@/vue/customer/job-profile/applicant/Actions.vue";
import EventBus from "@/event/EventBus";
import * as Event from "@/event/Event";

export default {

	components: {
		Actions,
		Button,
		Matching,
	},

	props: {
		jobProfileListItem: {
			type: Object,
			required: true,
		},
		jobId: {
			type: String,
			required: true,
		},
		applicant: {
			type: Object,
			required: true,
		},
		permissions: {
			type: Object,
			required: true,
		},
	},

	mounted ()
	{
		EventBus.$on(Event.JOB_PROFILE_APPLICANT_EXCLUDED, ({applicant, exclusionType}) =>
		{
			if (applicant.id === this.applicant.id)
			{
				this.exclusionType = exclusionType;
			}
		});

		EventBus.$on(Event.JOB_PROFILE_APPLICANT_EXCLUSION_REMOVED, ({applicant}) =>
		{
			if (applicant.id === this.applicant.id)
			{
				this.exclusionType = undefined;
			}
		});
	},

	data ()
	{
		return {
			localApplicant: this.applicant,
			inViewport: false,
			loadedMatching: false,
			exclusionType: undefined,
		};
	},

	computed: {
		applicantName ()
		{
			return this.localApplicant ? get(this.localApplicant) : '';
		},
		jobProfile ()
		{
			return this.jobProfileListItem.jobProfile;
		},
	},

	methods: {
		...mapActions('job/vita', {
			openVita: 'show',
		}),
		...mapActions('communication/contactApplicant', {
			openContactingFan: 'show'
		}),
		leavesViewport ()
		{
			// see documentation beneath why we are doing this
			if (this.inViewportTimeout)
			{
				clearTimeout(this.inViewportTimeout);

				this.inViewportTimeout = undefined;
			}
		},
		comesToViewport ()
		{
			// wait 1 second to say "we are in viewport" because matching gets executed then,
			// but maybe the user is scrolling fast by. in this case we do not want to have
			// a lot of parallel matching requests
			this.inViewportTimeout = setTimeout(async () =>
			{
				this.inViewport = true;

			}, 1000);
		},
		openVitaFan ()
		{
			new Add()
				.setCategory(PORTAL_CUSTOMER_VITA_LOAD)
				.setJob(this.jobId)
				.setJobProfile(this.jobProfile.id)
				.call();

			this.openVita({
				jobProfileListItem: this.jobProfileListItem,
				jobId: this.jobId,
				applicant: this.localApplicant,
				disclosedData: this.localApplicant.disclosedData,
				pseudonym: this.localApplicant.pseudonym,
				withActions: true,
				permissions: this.permissions,
				exclusionType: this.exclusionType,
				onContacted: () =>
				{
					this.reloadApplicant();
				},
				onFavored: () =>
				{
					this.reloadApplicant();
				},
			});
		},
		contactNow ()
		{
			new Add()
				.setCategory(PORTAL_CUSTOMER_CONTACTING_CLICK)
				.setJob(this.jobId)
				.setJobProfile(this.jobProfile.id)
				.call();

			this.openContactingFan({
				jobId: this.jobId,
				jobProfileId: this.jobProfile.id,
				applicant: this.localApplicant,
				onContacted: () =>
				{
					this.reloadApplicant();
				}
			});
		},
		async reloadApplicant ()
		{
			const response = await new GetList()
				.setJobProfileId(this.jobProfileListItem.jobProfile.id)
				.setJobId(this.jobId)
				.setOffset(0)
				.setLimit(1)
				.call();

			const applicants = response.data.applicants;

			// it could be that no applicant came back after loading as he was excluded / sent off
			if (applicants.length > 0)
			{
				const applicant = _.first(applicants);

				// force actions remount
				this.localApplicant = undefined;

				this.$nextTick(() => this.localApplicant = applicant);
			}
		}
	},
}
</script>
